import { reactular } from '@vendhq/reactular'
import { AblyProvider, ChannelProvider } from 'ably/react'
import React from 'react'

import { useAppSelector } from '../../state/hooks'
import { selectActiveRegisterId } from '../../state/slices/posState/posStateSlice'
import { FEATURE_STANDALONE_CUSTOMER_FACING_DISPLAY_ENABLED } from '../../constants/wr-features'
import { getFeatureFromCache } from '../../util/feature-cache'
import { SaleChangeEvents } from '../sale/sale-change-listener/sale-change-listener'
import { useByodRealtimeClient } from './hooks/useByodRealtimeClient'
import { useIsByodCfd } from './hooks/useRegisterCfdType'

interface ByodCfdRealtimeClientProps {
  registerId: string
}

const ByodCfdRealtimeClient: React.FC<ByodCfdRealtimeClientProps> = ({
  registerId,
}) => {
  const { client, channelName } = useByodRealtimeClient(registerId)
  if (!client || !channelName) {
    return null
  }

  return (
    <AblyProvider client={client}>
      <ChannelProvider channelName={channelName}>
        <SaleChangeEvents channelName={channelName} />
      </ChannelProvider>
    </AblyProvider>
  )
}

export const ByodCfdRealtimeHandler: React.FC = () => {
  const registerId = useAppSelector(selectActiveRegisterId)
  const isByod = useIsByodCfd()
  const byodFeatureEnabled = getFeatureFromCache(
    FEATURE_STANDALONE_CUSTOMER_FACING_DISPLAY_ENABLED
  )

  if (!registerId || !isByod || !byodFeatureEnabled) {
    return null
  }

  return <ByodCfdRealtimeClient registerId={registerId} />
}

export const ReactByodCfdRealtimeHandlerComponent = reactular(
  ByodCfdRealtimeHandler,
  [],
  'reactWrapper'
)
